import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientDebtorRelationViewModel } from '../../interface/company-client.interface';
import { ClientCompanyToDebtorRelationSummaryDTO } from '../../interface/company-to-debtor.interface';
import { ServiceInfoClientService } from '../../service/service-info-client.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Observable } from 'rxjs';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

@Component({
  selector: 'app-client-debtor-relationship-modal',
  templateUrl: './client-debtor-relationship-modal.component.html',
  styleUrls: ['./client-debtor-relationship-modal.component.scss']
})
export class ClientDebtorRelationshipModalComponent implements OnInit{

  public currentDate = new Date();
  public selectFilters: Array<any>;
  public filterForm: FormGroup;
  public clientDebtorRelationSummary$: Observable<ClientCompanyToDebtorRelationSummaryDTO | null>;

  constructor(
    @Inject(MAT_DIALOG_DATA)public viewModel: ClientDebtorRelationViewModel,
    private clientService: ServiceInfoClientService,
    private dialogRef: MatDialogRef<ClientDebtorRelationshipModalComponent>,
    private fb: FormBuilder,
  ){
    const defaultSelectRange = viewModel.datePreference;
    const {startDate, endDate} = viewModel

    this.setSelectFilters(this.currentDate);
    if(defaultSelectRange === 0) {
      this.filterForm = this.fb.group({
        start: startDate ? new Date(startDate): null,
        end: endDate ? new Date(endDate) : null,
        selectRange: defaultSelectRange
      });
      return;
    }

    this.filterForm = this.fb.group({
      start: null,
      end: null,
      selectRange: defaultSelectRange
    });
    this.clientDebtorRelationSummary$ = new Observable<ClientCompanyToDebtorRelationSummaryDTO | null>;
    this.setDateRangeFromSelect(defaultSelectRange);
  }

  ngOnInit(){
    this.getClientDebtorRelationSummary(this.viewModel);
  }

  getClientDebtorRelationSummary(viewModel: ClientDebtorRelationViewModel) {
    const {start, end} = this.filterForm.value;
    const {clientCompanyId, debtorCompanyId} = viewModel
    this.clientDebtorRelationSummary$ = this.clientService.getCompanyToDebtorRelationship(clientCompanyId, debtorCompanyId, start, end);
  }

  closeDialog(){ 
    this.dialogRef.close();
  }

  setSelectFilters(date: Date):void {
    const currentYear = date.getFullYear();
    this.selectFilters = [
      { value: 12, text: '12 Meses' },
      { value: 24, text: '24 Meses' },
      { value: 111, text: `Año Actual (${currentYear})` },
      { value: 222, text: `Año (${currentYear - 1})` },
      { value: 333, text: `Año (${currentYear - 2})` },
      { value: 1, text: 'Todo' },
      { value: 0, text: 'Personalizado'}
    ];
  }

  private setDateRangeFromSelect(selectVal: number) {
    let startDate: Date | null;
    let endDate: Date | null;

    switch(selectVal) {
      case 111:
        startDate = new Date(this.currentDate.getFullYear(), 0, 1);
        endDate = new Date(this.currentDate);  
        break;
      case 222:
        startDate = new Date(this.currentDate.getFullYear()-1 , 0, 1);
        endDate = new Date(this.currentDate.getFullYear()-1 , 12 ,0);
        break;
      case 333:
        startDate = new Date(this.currentDate.getFullYear()-2, 0, 1);
        endDate = new Date(this.currentDate.getFullYear()-2, 12, 0);
        break;
      case 1: //Todos
        startDate = null;
        endDate = null;
        break;
      default:
        startDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth()- selectVal, this.currentDate.getDate());
        endDate = new Date(this.currentDate);
        break;
    }
    this.filterForm.patchValue({
      start: startDate,
      end: endDate
    });
  }

  applyDateRangePicker() {
    this.filterForm.patchValue({
      selectRange: 0
    });
    this.getClientDebtorRelationSummary(this.viewModel);
  }

  changeDateInput(event: MatDatepickerInputEvent<Date>) {
    const {start, end } = this.filterForm.value;
    if(start && end){
      this.filterForm.patchValue({selectRange: 0});
      this.getClientDebtorRelationSummary(this.viewModel);
    }
  }


  public changeFilterSelect(change: MatSelectChange):void {
    const { value } = change;
    this.setDateRangeFromSelect(value);
    this.getClientDebtorRelationSummary(this.viewModel);
  }
}
